import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class ToastComponent extends Vue {
    @Prop({ default: false })
    value: boolean;

    @Prop({ default: 'v-slide-x-transition' })
    transitionComponent: string;

    @Prop()
    top: string;

    @Prop()
    right: string;

    @Prop()
    bottom: string;

    @Prop()
    left: string;

    get toastStyle() {
        if (!this.top && !this.right && !this.bottom && !this.left) {
            return 'top: 0;left: 0;';
        }

        let result = '';

        for (const direction of ['top', 'right', 'bottom', 'left']) {
            if (this[direction] || this[direction] == '0') {
                const propValue = this.hasUnit(this[direction])
                    ? this[direction]
                    : `${this[direction]}px`;

                result += `${direction}: ${propValue};`;
            }
        }

        if ((this.top || this.bottom) && !this.right && !this.left) {
            result += 'left: 50%';
        }

        if ((this.right || this.left) && !this.top && !this.bottom) {
            result += 'top: 50%';
        }

        return result;
    }

    get toastContentStyle() {
        let result = '';

        if ((this.top || this.bottom) && !this.right && !this.left ) {
            result += 'transform: translateX(-50%);';
        }

        if ((this.right || this.left) && !this.top && !this.bottom) {
            result += 'transform: translateY(-50%);';
        }

        return result;
    }

    hasUnit(value: string) {
        return value.toLowerCase().indexOf('px') > -1
            || value.toLowerCase().indexOf('%') > -1
            || value.toLowerCase().indexOf('em') > -1
            || value.toLowerCase().indexOf('rem') > -1;
    }
}
